export const termsExternalLinks = {
  term_of_use: `https://communicatr.co/help/terms-of-use.php`,
  disclaimer: `https://communicatr.co/help/disclaimer.php`,
  enduser_agreement: `https://communicatr.co/help/enduser-licenseagreement.php`,
  privacy_policy: `https://communicatr.co/help/privacy-policy.php`,
};
